<template>
  <a id="search-link" :title="translate('label.nav.search')" @click="showSearchField">
    <form id="search-form" :class="{ open: isOpen }" :action="searchUrl" method="get">
     <input type="text" name="q" id="searchterm" tabindex="1" value="" :placeholder="translate('label.search.placeholder')" @blur="hideSearchField" aria-label="">
     <input type="submit" value="" id="search-start-button" :title="translate('label.search.start')"> 
    </form>
  </a>
</template>

<script>
export default {
  props: {
      searchUrl: { type: String, required: true }
  },

  data() {
    return {
      isOpen: false
    }
  },

  methods: {
    showSearchField() {
      this.isOpen = true;
      window.setTimeout(function() {
                          document.getElementById("searchterm").select(); 
                        }, 100);
    },
    hideSearchField(evt) {
      try {
        evt.relatedTarget.id == "search-start-button";
      }
      catch(err) {
        this.isOpen = false;
      }
    },
    
  }
}
</script>

<style lang="scss" scoped>
 #search-link {
    position:relative;
    display:block;
    margin:-.5rem 0 0 1.5rem;
    width:1.5rem;
  #search-form {
    position:absolute;
    display:none; 
    top:-1rem;
    right:-.5rem;
    input#searchterm {
      width:30rem;
      height:3rem;
      padding:0 2rem 0 .75rem;
      border:0;
      border-radius:.25rem;
      background:transparent;
      &:focus {
        outline:none;
      }
    }
    #search-start-button {
      height: 1.3rem;
      width: 1.3rem;
      top:.925rem;
      right:.725rem;
      position:absolute; 
      padding:0;
      border:0;
      background-image: url("/img/ico-suche.svg");
      background-repeat: no-repeat;
      &:focus {
        outline:none;
      }
      cursor:pointer;
    }
    background:#fff;
    border-radius:.25rem;
  }
}

#search-link #search-form.open {
  display:block;
}

a#search-link, a#search-link:hover {
  border:0;
}

#search-link::before {
  height: 1.5rem;
  width: 1.5rem;
  top:-.125rem;
  left:0;
  position:absolute;
}

#search-link::before { content:url(/img/ico-suche.svg); }
</style>


